// adminSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchRoles,
  createRole,
  updateRole,
  addRoleToUser,
  removeRoleFromUser,
  fetchUsersByRoleId,
  fetchUsers,
  fetchUserDetail,
  fetchUsersWithStatistics,
  fetchUserStatistics,
} from "./adminThunk";

const initialState = {
  roles: [],
  users: [],
  userDetail: null,
  usersByRole: [],
  usersWithStatistics: [],
  userStatistics: null,
  status: "idle",
  statisticsLoading: false,
  error: null,
};

const adminApiSlice = createSlice({
  name: "adminApi",
  initialState,

  extraReducers: (builder) => {
    builder
      // ROLES
      .addCase(fetchRoles.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.status = "success";
        state.roles = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(createRole.fulfilled, (state, action) => {
        state.roles.push(action.payload);
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        const index = state.roles.findIndex((r) => r.id === action.payload.id);
        if (index !== -1) state.roles[index] = action.payload;
      })

      // USERS
      .addCase(fetchUsers.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = "success";
        state.users = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(fetchUserDetail.fulfilled, (state, action) => {
        state.userDetail = action.payload;
      })

      .addCase(fetchUsersByRoleId.fulfilled, (state, action) => {
        state.usersByRole = action.payload;
      })

      // USER ↔ ROLE
      .addCase(addRoleToUser.fulfilled, (state, action) => {
        if (state.userDetail) {
          state.userDetail.roles.push(action.payload);
        }
      })
      .addCase(removeRoleFromUser.fulfilled, (state, action) => {
        if (state.userDetail) {
          state.userDetail.roles = state.userDetail.roles.filter(
            (role) => role.id !== action.payload.id
          );
        }
      })

      // USER STATISTICS
      .addCase(fetchUsersWithStatistics.pending, (state) => {
        state.statisticsLoading = true;
      })
      .addCase(fetchUsersWithStatistics.fulfilled, (state, action) => {
        state.statisticsLoading = false;
        state.usersWithStatistics = action.payload;
      })
      .addCase(fetchUsersWithStatistics.rejected, (state, action) => {
        state.statisticsLoading = false;
        state.error = action.payload;
      })

      .addCase(fetchUserStatistics.pending, (state) => {
        state.statisticsLoading = true;
      })
      .addCase(fetchUserStatistics.fulfilled, (state, action) => {
        state.statisticsLoading = false;
        state.userStatistics = action.payload;
      })
      .addCase(fetchUserStatistics.rejected, (state, action) => {
        state.statisticsLoading = false;
        state.error = action.payload;
      });
  },
});

export default adminApiSlice.reducer;
